import { createSlice } from "@reduxjs/toolkit";
import { login, authenticate, logout } from "./../actions/AuthActions";


const AuthSlice = createSlice({
    name: "auth",
    initialState: {
        userId: null,
        userName: '',
        roleName: '',
        token: '',
        statusCode: 200,
        status: 'idle',
        error: "",
        loading: false,
        isLogin: false,
    },
    
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(login.fulfilled, (state, action) => {
                state.status = 'idle';
                const userData = action.payload.result;
                state.userId = userData.userId;
                state.userName = userData.userName;
                state.roleName = userData.roleName;
                state.token = userData.token;
                state.isLogin = true;
            })
            .addCase(login.rejected, (state, action) => {
                state.statusCode = action.payload.code;
                state.status = 'rejected';
                state.error = action.payload.message;
            })

            .addCase(authenticate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(authenticate.fulfilled, (state, action) => {
                state.status = 'idle';
                const userData = action.payload.result;
                state.userId = userData.userId;
                state.userName = userData.userName;
                state.roleName = userData.roleName;
                state.token = userData.token;
                state.isLogin = true;
            })
            .addCase(authenticate.rejected, (state, action) => {
                state.statusCode = action.payload.code;
                state.status = 'rejected';
                state.error = action.payload.message;
            })

            .addCase(logout.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(logout.fulfilled, (state) => {
                state.userId = null;
                state.userName = '';
                state.roleName = '';
                state.token = '';
                state.isLogin = false;
            })
            .addCase(logout.rejected, (state, action) => {
                state.statusCode = action.payload.code;
                state.status = 'rejected';
                state.error = action.payload.message;
            });
    },
});

export const { setToken } = AuthSlice.actions;

export default AuthSlice.reducer;
